export const earlyPayInOptions = Object.freeze([
  {
    value: "0",
    heading:
      "Early Payin of Securities during Market Hours",
    description:
      "Upon selling of securities that are free in your demat account (Not pledged or T1), if you opt for this option, early payin will happen during market hours. This gives you 80% of your holdings sale value as trading limits within 20 minutes. DP transaction charges are applicable per executed order as per the DP scheme opted by you.",
  },
  {
    value: "1",
    heading:
      "Early Payin of Securities at End of Day",
    description:
      "Upon selling of securities in your demat account, if you opt for this option, early payin will happen at end of day. You will not get 80% of your holdings sale value as trading limits within 20 minutes of execution of sale transaction. DP transaction charges are applicable per scrip as per the DP scheme opted by you.",
  },
]);

export const rmDetails = Object.freeze({
  name: "Arvind Kathappan",
  mailId: "helpdesk@nuvama.com",
});

export const smtfMsg = Object.freeze({
  error:
    "There was some problem in raising service request. Please try again later.",
  createSR: {
    headerText: "We have received your request!",
    content:
      "We have received your request for Early Payin During Market Hours/EOD. Your request will be processed by end of Day",
  },
});
